"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../../core/withCompInfo");
var utils_1 = require("../common/utils");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'compLayout', 'language'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, language = _a.language;
    return {
        showCount: compProps.showCount.toString(),
        showScreenName: compProps.showScreenName.toString(),
        accountToFollow: compData.accountToFollow.replace('@', ''),
        lang: utils_1.getLanguage(compProps.dataLang, language),
        width: compLayout.width || 0,
        height: compLayout.height || 0,
    };
});
//# sourceMappingURL=WTwitterFollow.js.map